import React from 'react';

export const useMenu = <T extends HTMLElement>() => {
   const [open, setOpen] = React.useState(false);
   const anchorRef = React.useRef<T>(null);

   const handleToggle = React.useCallback(() => {
      setOpen((prevOpen) => !prevOpen);
   }, []);

   const handleClose = React.useCallback((event: MouseEvent | TouchEvent) => {
      if (anchorRef.current && anchorRef.current.contains(event?.target as HTMLElement)) {
         return;
      }

      setOpen(false);
   }, []);

   const handleListKeyDown = React.useCallback((event: React.KeyboardEvent) => {
      if (event.key === 'Tab') {
         event.preventDefault();
         setOpen(false);
      }
   }, []);

   // return focus to the button when we transitioned from !open -> open
   const prevOpen = React.useRef(open);
   React.useEffect(() => {
      if (prevOpen.current === true && open === false) {
         anchorRef.current!.focus();
      }

      prevOpen.current = open;
   }, [open]);

   return {open, anchorRef, handleToggle, handleClose, handleListKeyDown};
};
